/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFontUpload } from '../../axios/customFontUpload'
import type {
	CustomFontUploadError,
	CustomFontUploadPathParams,
	CustomFontUploadRequest,
	CustomFontUploadResponse,
} from '../../types/CustomFontUpload'

export const customFontUploadMutationKey = () => [{ url: '/organisations/:organisation/fonts' }] as const

export type CustomFontUploadMutationKey = ReturnType<typeof customFontUploadMutationKey>

export type CustomFontUploadVariables = {
	organisation: CustomFontUploadPathParams['organisation']
	data: CustomFontUploadRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::upload */
export function useCustomFontUpload<TContext = unknown>(
	options?: UseMutationOptions<
		CustomFontUploadResponse,
		AxiosError<CustomFontUploadError>,
		CustomFontUploadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customFontUploadMutationKey(),
		mutationFn: ({ organisation, data }: CustomFontUploadVariables) =>
			customFontUpload(organisation, data, config).then(res => res.data),
		...options,
	})
}
